module.exports = __webpack_public_path__ + "assets/aa2c45bdd8f99273c6fed07818e42c2a.png";